// extracted by mini-css-extract-plugin
export var modal = "_su-0";
export var table = "_su-1";